/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: 22Y1UQmRX-g1
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicIndependentStory.module.css"; // plasmic-import: 22Y1UQmRX-g1/css

createPlasmicElementProxy;

export const PlasmicIndependentStory__VariantProps = new Array();

export const PlasmicIndependentStory__ArgProps = new Array();

const $$ = {};

function PlasmicIndependentStory__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__tQsJj)}>
        <div className={classNames(projectcss.all, sty.freeBox__mQ8WI)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__vwnkD
            )}
          >
            {"the independent."}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__x27T
            )}
          >
            {"Lorem ipsum dolor sit amet consectetur."}
          </div>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__mbEbn
          )}
        >
          <React.Fragment>
            <span
              className={
                "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
              }
              style={{ color: "var(--token-eOSTuajGvkxf)" }}
            >
              {
                "The independent is the individual who treats work as personal expression, builds a personal system to do it on his or her terms, and assumes direct responsibility for the decisions, standards, and outcomes that shape the work as it reaches others."
              }
            </span>
            <React.Fragment>{"\n\n"}</React.Fragment>
            <span
              className={
                "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
              }
              style={{ color: "var(--token-eOSTuajGvkxf)" }}
            >
              {"The personal system"}
            </span>
            <React.Fragment>
              {
                " he or she builds -- practice, studio, agency, firm, or something that doesn\u2019t even have a name yet -- is the"
              }
            </React.Fragment>
            <span
              className={
                "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
              }
              style={{ color: "var(--token-eOSTuajGvkxf)" }}
            >
              {" environment"}
            </span>
            <React.Fragment>
              {
                " that creates the conditions for his or her best work, and the "
              }
            </React.Fragment>
            <span
              className={
                "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
              }
              style={{ color: "var(--token-eOSTuajGvkxf)" }}
            >
              {"vehicle"}
            </span>
            <React.Fragment>
              {
                " through which that work becomes contribution.\n\nThis is who we build for. We share the same stance."
              }
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___1CBtR)}>
        <div className={classNames(projectcss.all, sty.freeBox__uStyq)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__yxGsB
            )}
          >
            {"the independent's story."}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__oUnMv
            )}
          >
            <React.Fragment>
              <span
                className={
                  "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                }
                style={{ color: "var(--token-micmDMnChhfU)" }}
              >
                {"The founder. The professional. The freelancer."}
              </span>
            </React.Fragment>
          </div>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__zkQcl
          )}
        >
          {
            "We now live in an era where the digital world has become the independent\u2019s primary workplace -- where work is coordinated, evaluated, documented, and cleared before it can move. A world where complexity and pace rise faster than human capacity. Where the independent is increasingly pushed to compete on institutional terrain without institutional leverage.\n\nUnder these conditions, the independent is gradually converted into an operator. Their work is increasingly converted into administration of systems required to deliver the work. Each new tool, vendor, handoff, requirement, or platform adds seams. Context switching becomes constant. Time moves from judgment and craft into interface management.\n\nAs more of the work moves through software layers, platforms, standards, and compliance, the work changes. And when the work -- and the independent\u2019s relationship to it -- changes shape, everything changes. Autonomy erodes as control over method, pace, standards, and attention narrows. Identity erodes as the work stops expressing the person. Impact diminishes as judgment is replaced by procedure.\n\nWhen autonomy, identity, and impact begin to erode, the independent doesn\u2019t stop wanting the work to be expressive and meaningful. He or she keeps going -- paying the cost in time, attention, and energy -- until the cost forces a structural decision.\n\nTo navigate the compounding operational load, the independent ultimately faces a decision between two default routes: accumulation, building institutional capacity piece by piece; or consolidation, joining a container that already has that capacity.\n\nAccumulation buys throughput in the short term. It also increases seams that must be managed: more handoffs, more tools that require integration, more roles to coordinate, more processes to maintain, and more context switching to keep everything aligned. What began as a personal system built to create conditions for craft -- focus, continuity, judgment, direct responsibility -- gets reorganized around operational maintenance: coordination, documentation, proof, follow-up, and the manual stitching required to keep the work moving. The independent\u2019s day follows that reorganization, and the work keeps converting into administration first and expressive second.\n\nConsolidation reduces the need to build that operational capacity internally. Complexity is carried by institutional defaults: templates, standardized workflows, predefined roles, centralized decisions, and systems optimized for consistency. Variation is treated as a cost to be reduced. The independent trades degrees of freedom in method, standards, and pace for a structure that can carry the operational load. Judgment shifts into procedure, and work converges toward what fits the container.\n\nBoth routes originate from institutional logic. Both manage complexity through standardization and centralized coordination. When the independent chooses accumulation, they gradually build that logic inside the personal system, adding layers until it starts to resemble a mini-institution. By choosing consolidation, they step into that logic from the outside, earlier.\n\nOver time, the structural outcome is similar. The independent is carried into operator roles. Decision rights drift away from the lived context. Methods are limited to what external systems can support at scale. The independent\u2019s stance changes with the shape of the work.\n\nThe story doesn\u2019t end here. The independent has always improvised and found a way inside systems that were not built for him or her. What makes today pivotal is the rate of change: complexity, pace, and interdependencies compound faster than the individual can learn and adapt without trading away autonomy.\n\nIf independence is to remain a real operating stance, the foundation beneath the personal system becomes the variable that matters -- because it shapes what independence becomes in a century defined by uncertainty and accelerating change."
          }
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicIndependentStory__ArgProps,
          internalVariantPropNames: PlasmicIndependentStory__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicIndependentStory__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicIndependentStory";
  } else {
    func.displayName = `PlasmicIndependentStory.${nodeName}`;
  }
  return func;
}

export const PlasmicIndependentStory = Object.assign(
  // Top-level PlasmicIndependentStory renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicIndependentStory
    internalVariantProps: PlasmicIndependentStory__VariantProps,
    internalArgProps: PlasmicIndependentStory__ArgProps
  }
);

export default PlasmicIndependentStory;
/* prettier-ignore-end */
